import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

if (process.env.NODE_ENV === "development" && typeof window !== "undefined") {
  const ignoreResizeObserverError = (event) => {
    const message = String(event?.message || "");
    if (message.includes("ResizeObserver loop completed with undelivered notifications")) {
      event.stopImmediatePropagation?.();
    }
  };
  window.addEventListener("error", ignoreResizeObserverError);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
const appTree = <App />;
root.render(process.env.NODE_ENV === "development" ? appTree : <React.StrictMode>{appTree}</React.StrictMode>);
